export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "tableQuery.worker.8961a9c4c9722d254473.worker.js");
}
